// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wrww","title":"Header_title__3_RM6","side":"Header_side__1ZDDM"};